import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Question Bank",
    description: "MCQ, descriptive, and multimedia questions organised by subject, topic, and difficulty.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 6h16M4 12h10M4 18h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="19" cy="18" r="2" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "AI Proctoring",
    description: "Webcam monitoring, tab-switch detection, and real-time malpractice alerts during exams.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="5" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 9l4-2v10l-4-2" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Auto Grading",
    description: "Instant scoring for objective questions with manual evaluation for subjective answers.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Results & Analytics",
    description: "Rank lists, performance reports, certificates, and statistical item analysis.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const OesIntroSection: React.FC = () => (
  <section className="wdev-intro" aria-labelledby="oes-intro-title">
    <div className="container">
      <div className="wdev-intro__grid">
        <AnimatedSection className="wdev-intro__content">
          <span className="wdev-label wdev-label--purple">Digital Assessment Platform</span>
          <h2 id="oes-intro-title" className="wdev-intro__title">
            Online Examination Software for Institutions
          </h2>

          <p className="wdev-intro__text">
            Schools, colleges, universities, and coaching centres need a reliable way to conduct
            exams remotely without compromising integrity. Our online exam software delivers secure,
            scalable assessments with built-in proctoring, flexible question types, and automated
            result processing.
          </p>
          <p className="wdev-intro__text">
            WebTech develops custom online examination platforms in Bangalore — from question bank
            management and timed exam delivery to AI proctoring, auto-grading, hall ticket generation,
            and integration with your existing LMS or ERP system.
          </p>

          <div className="wdev-intro__highlights">
            {highlights.map((item) => (
              <div className="wdev-intro__highlight" key={item.title}>
                <div className="wdev-intro__highlight-icon">{item.icon}</div>
                <div>
                  <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                  <p className="wdev-intro__highlight-desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>

        <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
          <EstimateProjectForm />
        </AnimatedSection>
      </div>
    </div>
  </section>
);

export default OesIntroSection;
